// Mobile-specific performance optimizations

// Detect mobile devices
export const isMobile = (): boolean => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    ) || window.innerWidth <= 768
  );
};

// Optimize for mobile viewport
export const optimizeViewport = () => {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.setAttribute(
      "content",
      "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover",
    );
  }
};

// Reduce animations on mobile for better performance
export const optimizeAnimations = () => {
  if (isMobile()) {
    // Add class to body for mobile-specific CSS
    document.body.classList.add("mobile-optimized");

    // Reduce motion for users who prefer it
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      document.body.classList.add("reduce-motion");
    }
  }
};

// Optimize touch interactions
export const optimizeTouch = () => {
  if (isMobile()) {
    // Add touch-action CSS to prevent unwanted gestures
    const style = document.createElement("style");
    style.textContent = `
      .mobile-optimized * {
        touch-action: manipulation;
      }
      .mobile-optimized .reduce-motion * {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
      }
    `;
    document.head.appendChild(style);
  }
};

// Lazy load non-critical resources on mobile
export const lazyLoadMobileResources = () => {
  if (isMobile()) {
    // Delay loading of non-critical scripts
    setTimeout(() => {
      // Load additional mobile-specific optimizations
      const script = document.createElement("script");
      script.src = "/mobile-optimizations.js";
      script.async = true;
      document.head.appendChild(script);
    }, 2000);
  }
};

// Optimize images for mobile
export const optimizeImagesForMobile = () => {
  if (isMobile()) {
    // Add responsive image loading
    const images = document.querySelectorAll("img");
    images.forEach((img) => {
      if (!img.hasAttribute("loading")) {
        img.setAttribute("loading", "lazy");
      }
    });
  }
};

// Initialize all mobile optimizations
export const initMobileOptimizations = () => {
  optimizeViewport();
  optimizeAnimations();
  optimizeTouch();
  // lazyLoadMobileResources();
  optimizeImagesForMobile();
};
